/* eslint-disable */
import de from 'vuetify/lib/locale/de';

export default {
  ...de,
  //  NOMES IDIOMAS
  idioma: 'Sprache',
  // GERAL
  meusDados: 'Mein profil',
  sair: 'Ausloggen',
  pesquisar: 'Suche',
  kanban: 'Kanban',
  todosClientes: 'Alle firmen',
  null: 'N/I',
  recusar: 'Verweigern',
  aceitar: 'Akzeptieren',
  selecionados: 'Ausgewählt',
  // NOVAS ATUALIZAÇÕES
  novasAtualizacoes: 'NACHRICHT!',
  // FILTROS
  pesquisarBy: 'Prozesse nach code oder referenz suchen',
  filtros: 'Filters',
  download: 'Download',
  periodo: 'Zeitspanne:',
  tipoData: 'Datumstyp:',
  mostrarEncerrados: 'Geschlossene prozesse anzeigen',
  encerrado: 'Geschlossen',
  Abertura: 'Öffnung',
  ETD: 'ETD',
  ETA: 'ETA',
  etd: 'ETD',
  eta: 'ETA',
  Embarque: 'Sendung',
  Chegada: 'Ankunft',
  Originais: 'Originale',
  'Registro DI': 'DI Register',
  removerFiltros: 'Filter entfernen',
  filtrar: 'Filter',
  ate: ' bis um ',
  warningFiltro: 'Wählen Sie einen gültigen Bereich und mindestens eine Kategorie aus.',
  // MENU
  dashboard: 'Dashboard',
  tituloTooltipDashboard: 'Zeigen Sie statistische Daten zur Leistung von Importprozessen an.',
  demandas: 'Liefern',
  abrirProcessos: 'Prozesse öffnen',
  novosProcessos: 'Neue Prozesse',
  tituloTooltipNovosProcessos: 'Inicia un nuevo proceso y espera su progreso para las etapas de importación. Edita los procesos haciendo doble clic en el campo deseado.',
  inicieUmNovoProcesso: 'Starten Sie einen neuen Prozess und warten Sie auf dessen Fortschritt für die Import-Schritte.',
  followUp: 'Nachverfolgen',
  inventario: 'Inventar',
  tituloTooltipEstoque:
    'Es hat den Zweck, ideale Lagerbestände in Übereinstimmung \nmit den Zielen und Anforderungen des Unternehmens zu halten.',
  armazem: 'Lagerhaus',
  financeiro: 'Finanziell',
  relatorios: 'Berichte',
  relatorio: 'Bericht',
  tituloTooltipRelatorios:
    'Planen Sie das Versenden von Berichten per E-Mail zu \nIhrem Prozess und bleiben Sie über die stattfindenden Updates auf dem Laufenden.',
  nomeRelatorio: 'Berichtsname',
  documentos: 'Unterlagen',
  base: 'Base',
  usuarios: 'Benutzer',
  tituloTooltipUsuarios: 'Registrieren Sie Benutzer, um Daten teilen zu können.',
  selecione: 'Wählen',
  selecioneTipo: 'Benutzertyp auswählen',
  claro: 'Licht',
  escuro: 'Dunkel',
  direitosReservados: 'Alle rechte vorbehalten',
  versao: 'Ausführung',
  termosCondicoes: 'Geschäftsbedingungen',
  politicasPrivacidade: 'Datenschutz-Bestimmungen',
  // ROLES
  ADMINISTRADOR: 'ADMINISTRATORIN',
  ANALISTA: 'ANALYTIKER',
  CLIENTE: 'KLIENT',
  CLIENTE_GESTOR: 'MANAGER',
  'CLIENTE GESTOR': 'MANAGER',
  CLIENTE_CONSULTOR: 'KUNDENBERATER',
  'CLIENTE CONSULTOR': 'KUNDENBERATER',
  // MODAL EXPORTAR EM EXCEL
  tituloModalExportar: 'In Excel-Datei exportieren',
  planilhaBaixada: 'Excel-Tabelle heruntergeladen',
  descricaoModalExportar: 'Wählen Sie die Spalten aus, die Sie anzeigen möchten.',
  disponiveis: 'Verfügbar',
  selecionadas: 'Ausgewählt',
  selecionarTodos: 'Wählen Sie Alle',
  removerTodos: 'Alles wiederufen',
  gerarArquivo: 'Erstelle Datei',
  Referência: 'Bezug',
  Processo: 'Prozess',
  'Status do Embarque': 'Versandstatus',
  'Unidade de Negócio': 'Geschäftsbereich',
  'Unidade de Medida': 'Maßeinheit',
  Quantidade: 'Menge',
  Exportador: 'Exporteur',
  Transportadora: 'Versandunternehmen',
  Produto: 'Produkt',
  'Conhecimento de Embarque': 'Frachtbrief',
  'Número DI': 'DI Nummer',
  'Canal DI': 'DI Kanal',
  Desembaraço: 'Veröffentlichung',
  Faturamento: 'Invoicing',
  'Nº NF Entrada': 'Fakturierung',
  Containers: 'Behälter',
  tituloTooltipContainers: 'Unverzichtbar für den Erfolg von Seefrachttransportoperationen, indem sie Effizienz, Sicherheit und Qualität für die Importprozesse gewährleisten.',
  'Emissão NF Entrada': 'Bordrechnungsausgabe',
  'Fechamento Operacional': 'Betriebsschließung',
  'Exec. Carregamento': 'Ausführung laden',
  'Licenças de Importação': 'Importlizenzen',
  'Armador/Agente de carga': 'Reeder/Fracht Agent',
  //COLUNAS KANBAN
  tituloTooltipKanban: 'Importflusspraxis anzeigen. Klicken Sie auf die Karte für weitere Details.',
  tooltipPreEmbarque: 'Eröffnungsdatum bis zum Versanddatum bearbeiten',
  tooltipTransito: 'Versanddatum bis zur Ankunft des Schiffes im Hafen',
  tooltipDesembaraco: 'Schiffsankunftsdatum bis zur DI-Freigabe',
  tooltipCarregamento: 'DI-Veröffentlichungsdatum bis zum Ladeschluss',
  tooltipFaturamento: 'Abschlussdatum bis zur Betriebsschließung laden',
  preEmbarque: 'Vorversand',
  transito: 'Auf der Durchreise',
  carregamento: 'Belastung',
  Carregamento: 'Belastung',
  carregamentoFaturamento: 'Laden/Abrechnung',
  carrFaturamento: 'Laden/Abr.',
  dataDoFaturamento: 'Rechnungsdatum',
  solicitacao: 'Anfrage',
  previsaoNaoInformada: 'Unbekannte Abfahrtsprognose',
  dataCarregamento: 'Ladetermin',
  dataFat: 'Datum fakt.',
  restam: 'links',
  dias: 'tage',
  dia: 'tag',
  Dias: 'Tage',
  atrasado: 'überfällig',
  emDesembaraco: 'In Freigabe: ',
  emCarregamento: 'In Belastung: ',
  emFaturamento: 'Bei der Rechnungsstellung: ',
  emFechamento: 'Abschließend: ',
  diaChegada: 'Voraussichtlicher Anreisetag',
  registro: 'registrieren',
  nenhumItemFoi: 'keine Ergebnisse',
  encontradoNaEtapa: 'gefunden auf',
  deFaturamento: 'Rechnungsstellung.',
  deCarregamento: 'Ladephase.',
  deDesembaraco: 'Release-Phase.',
  deTransito: 'Transitphase.',
  deEmbarque: 'Vorversandphase.',
  Fechamento: 'Schließung',
  'Em Trânsito': 'Unterwegs',
  'Em trânsito': 'Unterwegs',
  'Pré-Embarque': 'Pre-Boarding',
  // MODAL PROCESSO
  numeroContrato: 'Vertragsnummer',
  taxaCambial: 'Tauschrate',
  dataPagamento: 'Zahltag',
  valorReal: 'Wert in BRL',
  variacaoCambial: 'Austauschvariante',
  cambio: 'Wechselkurs',
  tituloTooltipCambio: 'Verfolgen Sie die Zahlungsmodalitäten, Fälligkeitsdaten und Verhandlungsarten.',
  informacoes: 'Information',
  invoices: 'Rechnungen',
  contaCorrente: 'Girokonto',
  maritima: 'Maritim',
  rodoviaria: 'Straße',
  aerea: 'Antenne',
  embarque: 'Abfahrt',
  informacoesGerais: 'Allgemeine Information',
  tipoProcesso: 'Prozesstyp',
  unidadeNegocio: 'Geschäftsbereich',
  referenciaInterna: 'Interne Referenz',
  referenciaTrust: 'Trust Referenz',
  referenciaCliente: 'Kundenreferenz',
  'Referência Cliente': 'Kundenreferenz',
  'Referência Trust': 'Trust Referenz',
  cliente: 'Klient',
  exportador: 'Exporteur',
  produto: 'Produkt',
  invoice: 'Rechnung',
  cidadeEmbarque: 'Versandstadt',
  cidadeDestino: 'Zielstadt',
  'CONTA E ORDEM': 'RECHNUNG UND BESTELLUNG',
  'CONTA E ORDEM DE TERCEIROS': 'RECHNUNG UND BESTELLUNG',
  'CONTA PRÓPRIA': 'EIGENER ACCOUNT',
  'CONTA PROPRIA': 'EIGENER ACCOUNT',
  'IMPORTAÇÃO POR ENCOMENDA': 'IMPORTER BY ORDER',
  transporteLogistica: 'Transport und Logistik',
  statusEmbarque: 'Versandstatus',
  modal: 'Modalität',
  tipoCarga: 'Ladetyp',
  incoterm: 'INCOTERM',
  incoterms: 'Incoterms',
  conhecimento: 'Frachtbrief',
  navioVeiculo: 'Schiff/Fahrzeug',
  containers: 'Containers',
  container: 'Container',
  Container: 'Container',
  containerConsolidado: 'Konsolidierter container',
  devolucaoContainer: 'Container-Rückgabe',
  pesoBrutoKG: 'Bruttogewicht(KG)',
  pesoLiquidoKG: 'Reingewicht(KG)',
  URFEntrada: 'URF Eingang/Ankunft',
  freeTime: 'Free Time',
  freetime: 'Free Time',
  freteCollect: 'Fracht sammeln',
  fretePrepaid: 'Fracht vorausbezahlt',
  valorTotalFrete: 'Gesamtfrachtkosten',
  moedaFrete: 'Versandwährung',
  embalagemFrete: 'Verpackung',
  quantidadeEmbalagem: 'Verpackungsmenge',
  datasPrevistas: 'Voraussichtliche Termine',
  previsaoEmbarque: 'Versandprognose',
  previsaoChegada: 'Ankunftsprognose',
  datasConfirmadas: 'Bestätigte Termine',
  dataEmbarque: 'Versanddatum',
  dataChegada: 'Ankunftsdatum',
  datasLiberacoes: 'Termine und Veröffentlichungen',
  dataLiberacaoSiscarga: 'Erscheinungsdatum von Siscarga',
  dataLiberacaoMapa: 'Erscheinungsdatum der Karte',
  liberacaoMinisterioAgricultadoPecuaria: 'MAPA Freigabedatum',
  ultimaMovimentacao: 'Letzter Zug',
  presencaCarga: 'Präsenz laden',
  licencasImportação: 'Importlizenzen',
  tituloTooltipLI: 'Verfolgen Sie die für die Einfuhr erforderlichen Lizenzen, mit dem Ziel der Regulierung des internationalen Handels und des Schutzes der nationalen Wirtschaft.',
  numLi: 'LI-Nummer',
  orgaoAnuente: 'Zustimmung',
  dataRegistro: 'Registrierungsdatum',
  dataStatus: 'Status Datum',
  dataValidade: 'Verfallsdatum',
  statusLicenca: 'Lizenzstatus',
  'Status L.I': 'Lizenzstatus',
  declaracaoImportacao: 'Einfuhranmeldung',
  numeroRegistro: 'Registrationsnummer',
  dataDesembaraco: 'Veröffentlichungsdatum',
  canalParametrizacao: 'Parametrierungskanal',
  paramtrizacao: 'Parametrisierung',
  atualizacoes: 'Aktualisierung',
  ultimaAtualizacao: 'Letzte Aktualisierung',
  dataNaoInformada: 'Datum nicht mitgeteilt',
  baixarTodos: 'Alles Download',
  solicitacaoNumerario: 'Bargeldanforderung',
  descricao: 'Beschreibung',
  dataSolicitacao: 'Anforderungsdatum',
  'Data de solicitação': 'Anforderungsdatum',
  acessar: 'Zugang',
  Acessar: 'Zugang',
  fechamentoProcesso: 'Prozessabschluss',
  visualizar: 'visualisieren',
  Visualizar: 'visualisieren',
  processo: 'Prozess',
  data: 'Datum',
  formacaoValorAduaneiro: 'Zollwertbildung',
  valorAduaneiroEstimado: 'Geschätzter Zollwert',
  composicao: 'Komposition',
  moeda: 'Währung',
  Moeda: 'Währung',
  valorNegociado: 'Ausgehandelter Wert',
  valorBRL: 'BRL Wert',
  impostos: 'Besteuerung',
  despesasNacionalizacao: 'Verstaatlichungskosten',
  icmsIpiTransferencia: 'ICMS/IPI Übertragung',
  referencia: 'Hinweis',
  codigoProcesso: 'Prozesscode',
  'II - IMPOSTO DE IMPORTAÇAO': 'Wichtige Steuer',
  naoInformado: 'Nicht informiert',
  semAtualizacoes: 'Keine Aktualisierungen',
  as: 'bei',
  semDocumentos: 'Keine Dokumente vorhanden',
  solicitar: 'Anfrage',
  documento: 'Dokumentieren',
  dataEmissao: 'Ausstellungsdatum',
  numerario: 'Kasse',
  total: 'Gesamt',
  Total: 'Gesamt',
  nenhumaInformacao: 'Keine Ergebnisse gefunden',
  notasComplementares: 'Ergänzende Rechnungen',
  notasFiscalEletronica: 'E-Rechnung',
  valorNota: 'Rechnungsbetrag',
  numeroNota: 'Rechnungsnummer',
  codigoDocumento: 'Dokumentcode',
  totalBruto: 'Bruttogewicht insgesamt',
  totalLiquido: 'Nettogewicht insgesamt',
  despesa: 'Kosten',
  valorBruto: 'Bruttowert',
  valorLiquido: 'Nettowert',
  meioUtilizado: 'Gebrauchtes Transportfahrzeug',
  lclFcl: 'LCL (Consolidated/Loose Cargo), FCL (In container)',
  tipoBL: 'B/L-Nummer (Frachtbrief)',
  recintoDesembaraco: 'Zollfreigabebereich',
  unidadeReceitaFederal: 'Bundesfinanzeinheit bezogen auf den Eingangshafen',
  VERDE: 'GRÜN',
  AMARELO: 'GELB',
  VERMELHO: 'ROT',
  CINZA: 'GRAU',
  invoicesProcesso: 'Rechnungen bearbeiten',
  numeroInvoice: 'Rechnungscode',
  itensInvoice: 'Rechnungspositionen',
  item: 'Artikel',
  Item: 'Artikel',
  fabricante: 'Hersteller',
  Fabricante: 'Hersteller',
  NCM: 'NCM',
  quantidade: 'Anzahl',
  condicaoPagamento: 'Zahlungsbedingungen',
  'Condição de pagamento': 'Zahlungsbedingungen',
  unidadeMedida: 'Maßeinheit',
  'Unidade de medida': 'Maßeinheit',
  valorUnitario: 'Einheitswert',
  'Valor Unitário': 'Einheitswert',
  totalCredito: 'Gesamtkredit',
  totalDebito: 'Schulden insgesamt',
  diferenca: 'Unterschied',
  origem: 'Herkunft',
  Origem: 'Herkunft',
  evento: 'Veranstaltung',
  Evento: 'Veranstaltung',
  credito: 'Anerkennung',
  Crédito: 'Anerkennung',
  debito: 'Schulden',
  Débito: 'Schulden',
  vencimento: 'Geburtstermin',
  Vencimento: 'Geburtstermin',
  complemento: 'Ergänzen',
  Complemento: 'Ergänzen',
  mapa: 'Karte',
  notaFiscalEntrada: 'Eingangsrechnung',
  ENCOMENDA: 'BESTELLUNG',
  PROPRIO: 'BESITZEN',
  PRÓPRIO: 'BESITZEN',
  'ENCOMENDA PADRAO': 'STANDARD-BESTELLUNG',
  'ENCOMENDA PADRÃO': 'STANDARD-BESTELLUNG',
  'ENCOMENDA ESPECIAL': 'SONDERBESTELLUNG',
  'Nº da LI': 'LI-Nummer',
  'Órgão anuente': 'Anuent Orgel',
  'Data de registro': 'Datum der Registrierung',
  'Data de status': 'Statusdatum',
  'Data de validade': 'Verfallsdatum',
  'Status da licença': 'Lizenzstatus',
  'SEM PARAMETRO': 'OHNE PARAMETER',
  //MAPA
  maritimo: 'Maritim',
  rodoviario: 'Straße',
  todos: 'Alles',
  abrirProcesso: 'Neuer Prozess',
  abrirProcessoNovaAba: 'Vorgang in einem neuen Tab öffnen',
  embarcacao: 'Schiffe',
  veiculos: 'Fahrzeuge',
  portos: 'Häfen',
  armazemTaglog: 'TRUST Lagerhaus',
  agrupamentos: 'Gruppen',
  trajetoPrevisto: 'Vorhergesagter Weg',
  trajetoPercorrido: 'Begangener Weg',
  cotacao: 'Preis',
  dolar: 'Dollar',
  euro: 'Euro',
  especialistaComex: 'COMEX Spezialist',
  email: 'E-mail',
  celularWhatsapp: 'WhatsApp',
  destino: 'Ziel',
  navio: 'Schiff',
  Navio: 'Schiff',
  visualizarProcesso: 'Prozess ansehen',
  porto: 'Hafen',
  numeroPassagens: 'Totale Passagen',
  CNPJ: 'DOC',
  localizacao: 'die Anschrift',
  naviosAgrupados: 'Gruppierte Schiffe',
  portosAgrupados: 'Gruppierte Häfen',
  clientesAgrupados: 'Gruppierte Kunden',
  viagensAgrupados: 'Gruppenreisen',
  CTE: 'CTe nummer.',
  viagem: 'Reisen',
  atualizadoEm: 'Aktualisiert am:',
  por: 'durch',
  status: 'Status',
  remetente: 'Absender',
  destinatario: 'Empfänger',
  destinatarios: 'Empfänger',
  informacaodeCarga: 'Informationen laden',
  valorCarga: 'Ladewert',
  valorCargaAverbada: 'Registrierter Ladewert',
  valorPrestado: 'Gelieferter Wert',
  valorRecebido: 'Erhaltener Wert',
  // MODAL SELECIONAR CLIENTES
  selecionarClientes: 'Kunden nternehmen',
  //ABERTURA DE PROCESSO
  aberturaProcesso: 'Lieferanfrage',
  solicitarCancelamento: 'Beantragen Sie die Stornierung des Prozesses',
  processoAtualizado: 'Ihr Prozessantrag wurde aktualisiert',
  solicitarAlteracao: 'Änderung anfordern',
  alteracoesEncaminhadas: 'Ihre Änderungen wurden gespeichert und werden an unsere Spezialisten zur Überprüfung weitergeleitet',
  jaPossuiAlteracao: 'Dieser Prozess hat bereits eine Änderungsanfrage',
  aguardandoCancelamento: 'Warten auf Stornierung des Prozesses',
  aguardandoAprovaoAlteracao: 'Warten auf Genehmigung der Änderung',
  solicitacaoAlteracaoPendente: 'Sie haben eine ausstehende Änderungsanfrage in diesem Prozess',
  alteracoesFeitas: 'Änderungen vom Kunden vorgenommen',
  aceitarSolicitacaoPendente: 'Änderungsanfrage im Prozess akzeptieren',
  desejaAceitarAsAlteracoes: 'Möchten Sie die Änderungen akzeptieren?',
  casoAceite: 'Wenn Sie bestätigen, werden die Daten dieses Prozesses geändert',
  seVoceConfirmar: 'Wenn Sie diese Anfrage bestätigen, wird sie die aktuell ausstehende Anfrage überschreiben',
  emCancelamento: 'Bei Stornierung',
  suaSolicitacaoDeCancelamento: 'Ihre Stornierungsanfrage wurde an unsere Experten weitergeleitet',
  exibirColunas: 'Spalten anzeigen',
  'Tipo Importação': 'Importtyp',
  Finalidade: 'Thema',
  modelosProntos: 'Fertige Vorlagen',
  Empresa: 'Gesellschaft',
  nomeEmpresa: 'Firmenname',
  'Solicitado em': 'Angefordert unter',
  solicitadoPor: 'Angefordert von',
  responsavel: 'Verantwortlich',
  Ações: 'Aktionen',
  responsaveisNaoVinculados: 'Mit Ihrem Unternehmen sind keine repräsentativen Kontakte verknüpft',
  registrosPorPagina: 'Registrieren Sie sich pro Seite',
  registros: 'Registriert',
  resultados: 'Ergebnisse',
  editar: 'Bearbeiten',
  editarItem: 'Element bearbeiten',
  remover: 'Entfernen',
  solicitarAbertura: 'Angebot anfordern',
  itens: 'Artikel',
  Itens: 'Artikel',
  observacao: 'Überwachung',
  anexarArquivos: 'Dateien anhängen',
  arquivosAnexados: 'Angehängte Dateien',
  adicionarArquivos: 'Datei hinzufügen',
  salvar: 'Sparen',
  tipoDocumento: 'Dokumentenart',
  escolherArquivo: 'Datei wählen',
  unidadeComercializada: 'Handelsübliche Maßeinheit',
  carregando: 'Loading',
  tooltipMercosul:
    'Gemeinsame Namen für Mercosul (Code zur Identifizierung von Produkten in Brasilien, Argentinien, Paraguai, Uruguai und anderen Ländern des Mercosul)',
  modificar: 'Ändern',
  // LISTAGEM DE PROCESSOS
  cadastrarProduto: 'Produkt registrieren',
  editarProduto: 'Produkt bearbeiten',
  adicionarProduto: 'Produkt hinzufügen',
  adicionadoProduto: 'Produkt hinzugefügt',
  produtoAdicionado: 'Produkt hinzugefügt! Produkt registrieren?',
  indice: 'Index',
  todosCamposObrigatorios: 'Alle Felder sind Pflichtfelder.',
  preenchaCamposObrigatorios: 'Bitte füllen Sie alle Pflichtfelder aus',
  confirmarRemoverLista:
    'Sind Sie sicher, dass Sie dieses Produkt aus der Liste entfernen möchten?',
  cadastroFuturo: 'Sie können es in Zukunft wieder registrieren.',
  editarReferencia: 'Referenz bearbeiten',
  codigoCliente: 'Kundennummer',
  grupo: 'Gruppe',
  fornecedor: 'Anbieter',
  produtor: 'Produzent',
  Fornecedor: 'Anbieter',
  Produtor: 'Produzent',
  produtorFabricante: 'Produzent / Hersteller',
  codigoTrust: 'Trust-Code',
  textoNCM:
    'Beim Registrieren können Sie dieses Produkt bei der Eingabe des NCM in anderen Operationen verwenden.',
  cadastrar: 'Registrieren',
  Importador: 'Importeur',
  // LISTAGEM DE PROCESSOS
  listagemProcessos: 'Prozessliste',
  processosAfiliados: 'Affiliates Nachverfolgung',
  tituloTooltipListagemProcessos:
    'Alle Prozesse in der Liste, die gefiltert \nund in Modellen gespeichert werden können, um die Nutzung zu erleichtern.',
  modeloRelatorios: 'Modelle melden',
  relatorioSalvo: 'Bericht wurde erfolgreich gespeichert',
  relatorioAtualizado: 'Bericht wurde erfolgreich aktualisiert',
  relatorioSemDescricao: 'Ein Bericht kann nicht ohne Beschreibung gespeichert werden',
  criarModeloRelatorio: 'Erstellen Sie ein neues Berichtsmodell',
  alterarModeloRelatorio: 'Berichtsmodell aktualisieren',
  digiteAqui: 'Hier eingeben',
  digiteAquiNCM: 'Suchen Sie hier nach NCM',
  selecioneColunas: 'Wählen Sie Spalten aus, die Sie in der Liste anzeigen möchten',
  criarRelatorio: 'Bericht erstellen',
  atualizarRelatorio: 'Bericht aktualisieren',
  relatorioAplicado: 'Angewandter bericht',
  listagem: 'Aufführen',
  deferimentoLi: 'LI-Genehmigung',
  //INVENTARIO
  de: 'von',
  fraseEstoqueMiniRefpart1: 'Der Referenzwert ist der aktuelle Lagerbestand. Das bedeutet, dass wenn das Kontrollkästchen markiert ist, der Mindestbestand sein wird.',
  fraseEstoqueMiniRefpart2: '% verfügbares aktuelles Lager',
  estoqueMinimoMensagemPorcentagemAviso: 'Beim Auswählen des Bestands nach Prozent sollte es zwischen 1 und 200 liegen.',
  valorPorPercentagemEstoque: 'Mindestbestandsprozentsatz (%) des aktuellen Bestands',
  'Código do produto': 'Produktcode',
  'Nome do Produto': 'Produktname',
  'Categoria do NCM': 'NCM-Kategorie',
  'Previsão no armazém': 'Lagerprognose',
  estabelecimento: 'Einrichtung',
  descricaoGrupo: 'Gruppenbeschreibung',
  quantidadeAtual: 'Aktuelle menge',
  situacao: 'Situation',
  descricaoEndereco: 'Beschreibung Adresse',
  inventarioDescricao: 'Inventar für den Vortag',
  descricaoProduto: 'Produktbeschreibung',
  depositante: 'Einleger',
  tipoUnidade: 'Gerätetyp',
  classe: 'Klasse',
  quantidadeEmpenhado: 'Zugesagte Menge',
  quantidadeReserva: 'Reservemenge',
  armazenadoEm: 'Gespeichert in',
  quantidadeProdutosEmTransito: 'Menge der Produkte im Transit',
  quantidadeProdutosAtual: 'Aktuelle Produktmenge',
  //ARMAZEM
  //RELATORIOS
  adicionar: 'Hinzufügen',
  Habilitado: 'Verfügbar',
  Descrição: 'Bezeichnung',
  desabilitado: 'Nicht verfügbar',
  'Dias da Semana': 'Wochentage',
  Horário: 'Zeit',
  'E-mails': 'E-Mails',
  adicionarRelatorio: 'Bericht hinzufügen',
  editarRelatorio: 'Bericht aktualisieren',
  conteudoRelatorio: 'Berichtsinhalt',
  escolhaColunasFiltros: 'Wählen Sie die Spalten oder wählen Sie einen bevorzugten Filter',
  escolhaColunasFiltrosIntro1: 'Sie können einen Filter mit den Spaltenoptionen, die Sie bevorzugen, als Favorit markieren.',
  escolhaColunasFiltrosIntro2: 'Diese Funktion ist auch in der Prozessliste verfügbar und ermöglicht es Ihnen, die Prozessanzeige nach Ihren Bedürfnissen zu filtern.',

  habilitarAgendamento: 'Schalte den Zeitplan ein',
  cancelar: 'Abbrechen',
  naoCancelar: 'Nicht stornieren',
  excluirAgendamento: 'Berichtszeitplan entfernen?',
  naoRecuperavel: 'Wenn Sie bestätigen, ist es nicht möglich, dieses Element wiederherzustellen.',
  excluirAberturaProcesso: 'Lieferauftrag entfernen?',
  nossosEspecialistasVao:
    'Unsere Spezialisten werden Ihre Anfrage erhalten und wir werden Ihnen per E-Mail mit den Anpassungen antworten',
  recuperavel: 'Sie können nach dem Entfernen wiederherstellen.',
  excluido: 'Erfolg löschen',
  voltarAgendamentos: 'Zurück zur Berichtsliste',
  tenteNovamente: 'Bitte versuche es erneut.',
  confirmar: 'Bestätigen',
  'Un. de Negócio': 'Geschäftsbereich',
  'Un. de Medida': 'Maßeinheit',
  //GED
  ged: 'Elektronische Dokumentenverwaltung',
  baixarSelecionados: 'Ausgewählte herunterladen',
  visualizarSelecionados: 'Ausgewählte anzeigen',
  Documento: 'Dokumentieren',
  Tipo: 'Typ',
  Extensão: 'Verlängerung',
  arquivoNaoSuportado: 'Die Datei muss die Erweiterung xlsx, xls oder csv haben',
  Data: 'Datum',
  //USUARIOS
  Foto: 'Foto',
  Código: 'Code',
  'Criado em': 'Hergestellt in',
  'Nome completo': 'Vollständiger Name',
  Email: 'E-mail',
  senha: 'Passwort',
  confirmarSenha: 'Passwort bestätigen',
  criarSenha: 'Passwort erstellen',
  caracteresSenha: '8 bis 25 Zeichen',
  maiusculas: 'Mindestens ein Großbuchstabe',
  letrasNumeros: 'Zahlen und Buchstaben',
  caractereEspecial: "Spezielle Charaktere ! @ # $ % & * ' _ + = [ ] { } | : . ? ~ ( ) ; ,",
  adicionarUsuario: 'Nutzer hinzufügen',
  editarUsuario: 'Benutzer bearbeiten',
  CNPJContatos: 'Repräsentative Kontakte & DOC',
  notificacoes: 'Benachrichtigungen',
  fotoPerfil: 'Profilbild',
  opcional: 'Optional',
  empresas: 'Firmen',
  empresa: 'Unternehmen',
  tituloTooltipEmpresas: 'View the DNA and the people in charge of the registered companies.',
  tipoUsuario: 'Benutzertyp',
  responsavelComercial: 'Handelsvertreter',
  nome: 'Name',
  responsavelOperacional: 'Operational manager',
  clientesCNPJ: 'Linked DOCs',
  consultarCNPJ: 'Link CNPJ',
  'Cód. Conexos': 'Conexos code',
  Nome: 'Name',
  Cidade: 'Stadt',
  UF: 'Zustand',
  'Razão Social': 'Firmenname',
  adicionarSelecionados: 'Auswahl hinzufügen',
  receberNotificacoes: 'Benachrichtigungen erhalten',
  notificacoesWhatsapp: 'WhatsApp-Benachrichtigungen',
  tipoNotificacao: 'Benachrichtigungstypen',
  //DASHBOARD
  bemVindo: 'Herzlich willkommen',
  tempoLiberacao: 'Freigabezeit (Tage)',
  tempoLiberacaoProduto: 'Freigabezeit nach Produkt (Tage)',
  top10Produtos: 'Top 10 Produkte',
  acertoNumerario: 'Bargeld trifft (%)',
  tempoMedioFechamento: 'Durchschnittliche Schließzeit (days)',
  processos: 'Prozesse',
  processoAberto: 'Ihr Prozess wurde erfolgreich geöffnet.',
  statusProcesso: 'Prozessstatus (%)',
  faturamento: 'Fakturierung',
  emTempo: 'Pünktlich',
  verde: 'Grün',
  vermelho: 'Rot',
  amarelo: 'Gelb',
  cinza: 'Grau',
  Janeiro: 'Januar',
  Fevereiro: 'Februar',
  Março: 'Marsch',
  Abril: 'April',
  Maio: 'Kann',
  Junho: 'Juni',
  Julho: 'Juli',
  Agosto: 'August',
  Setembro: 'September',
  Outubro: 'Oktober',
  Novembro: 'November',
  Dezembro: 'Dezember',
  janeiro: 'Januar',
  fevereiro: 'Februar',
  marco: 'Marsch',
  abril: 'April',
  maio: 'Kann',
  junho: 'Juni',
  julho: 'Juli',
  agosto: 'August',
  setembro: 'September',
  outubro: 'Oktober',
  novembro: 'November',
  dezembro: 'Dezember',
  // FINANCEIRO
  modalidade: 'Modus',
  porcentagem: 'Prozentsatz',
  tipoVencimento: 'Ablauftyp',
  dataVencimento: 'Geburtstermin',
  valor: 'Wert',
  undefined: 'Objekt nicht gefunden',
  // MENSAGEIRO
  mensageiro: 'Briefträger',
  tituloTooltipMensageiro:
    'Planen Sie das Versenden von Berichten per E-Mail zu \nIhrem Prozess und bleiben Sie über die stattfindenden Updates auf dem Laufenden.',
  Responsável: 'Verantwortlich',
  'Última execução': 'zuletzt gesendet',
  excluirAgendamentoPadrao: 'Zeitplan löschen?',
  excluirProduto: 'Produkt löschen?',
  enviarEmail: 'E-Mail jetzt senden',
  agendamento: 'Planer',
  agendar: 'Zeitlicher Ablauf',
  erroSalvarAgendamentoMensageiro:
    'Etwas ist schief gelaufen, der Zeitplan konnte nicht gespeichert werden!',
  preenchaTodoAgendamento: 'Bitte füllen Sie alle Felder aus',
  agendamentoSalvoComSucesso: 'Der Zeitplan wurde gespeichert',
  redirecionamentoTelaListagem: 'Sie werden zum Auflistungsbildschirm weitergeleitet',
  Copiar: 'Kopieren',
  Reenviar: 'Nochmals senden',
  enviar: 'senden',
  enviarEmailAgora: 'E-Mail jetzt versenden?',
  sucessoEnvioEmail: 'E-Mail erfolgreich versendet!',
  processoCompartilhadoSucesso: 'Die Prozesse wurden erfolgreich geteilt!',
  adiantado: 'im Voraus',
  obrigatorio: 'Achtung: Pflichtfeld.',
  emailInvalido:
    'Die eingegebene E-Mail-Adresse scheint falsch zu sein. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
  cnpjInvalido: 'Achtung: Ungültiger CNPJ.',
  senhaInvalida: 'Warnung: Passwort entspricht nicht den Anforderungen',
  senhasDiferentes: 'Achtung: Die Passwörter stimmen nicht überein',
  // notificações
  chegada: 'Ankunft',
  ativarNotificacoes: 'Alle Benachrichtigungen einschalten',
  embarquePrevisto: 'Geplanter Versand',
  embarqueEfetivo: 'Effektiver Versand',
  manifestoCarga: 'Frachtmanifest',
  emailDestino: 'Ziel-E-Mails',
  empresaSelecionadaNaoExiste: 'Das ausgewählte Unternehmen ist nicht registriert',
  cadastroEmpresa: 'Firmenregistrierung',
  cadastroUsuario: 'Benutzerregistrierung',
  emailEnviado: 'E-Mail erfolgreich versendet',
  vincularEmpresa: 'Unternehmen verlinken',
  frequencia: 'Frequenz',
  campos: 'Felder',
  transitTime: 'Transitzeit',
  tituloTooltipTransitTime:
    'Betrachten Sie den Fortschritt des Prozesses \nzwischen den Stufen und die voraussichtliche Fertigstellungszeit.',
  ano: 'Jahr',
  dom: 'Son',
  seg: 'Mon',
  ter: 'Die',
  qua: 'Mit',
  qui: 'Don',
  sex: 'Fre',
  sab: 'Sam',
  DI: 'DI',
  siscarga: 'Siscarga',

  // Tour
  tourCancelar: 'Abbrechen',
  tourVoltar: 'Zurück',
  tourProximo: 'Weiter',
  tourFinalizar: 'Abschließen',

  tourBemVindo: 'Willkommen!',
  tourBemVindoMensagem: 'Wir zeigen Ihnen unsere wichtigsten Funktionen, es dauert nur einen Moment.',

  tourMapa: 'Karte',
  tourMapaMensagem: 'Verfolgen Sie den Versand von Seefracht und Straßentransporten sowie von Häfen, Lagerhäusern und Herstellern.',

  tourDashboard: 'Dashboard',
  tourDashboardMensagem: 'Sehen Sie sich Diagramme und Statistiken zu Ihren Prozessen, Produkten, Bargeld und anderen Informationen an.',

  tourFollowUp: 'Follow-Up',
  tourFollowUpMensagem: 'Verfolgen Sie Ihren Prozess durch die Importphasen.',

  tourMenu: 'Menü',
  tourMenuMensagem: 'Ein aufklappbares Menü, das Ihnen Zugriff auf die anderen verfügbaren Module des Systems bietet.',

  tourProcessos: 'Prozesse öffnen',
  tourProcessosMensagem: 'Öffnen Sie Prozesse und warten Sie auf deren Fortschritt.',

  tourGestaoLi: 'Gestão LI',
  tourGestaoLiMensagem: 'Überprüfen Sie die für den Import erforderlichen Lizenzen.',

  tourDocumentos: 'Dokumente',
  tourDocumentosMensagem: 'Analysieren Sie Dokumente im Zusammenhang mit Ihren Prozessen.',

  tourAgendarRelatorios: 'Berichte planen',
  tourAgendarRelatoriosMensagem: 'Planen Sie benutzerdefinierte Berichte, die per E-Mail gesendet werden.',

  tourUsuarios: 'Benutzer',
  tourUsuariosMensagem: 'Fügen Sie Benutzer hinzu und konfigurieren Sie sie, um das System gemeinsam zu nutzen.',

  tourSelecaoEmpresas: 'Unternehmensauswahl',
  tourSelecaoEmpresasMensagem: 'Filtern Sie die Unternehmen, die Sie anzeigen möchten, anhand der CNPJ.',

  tourChat: 'Chat',
  tourChatMensagem: 'Stellen Sie Fragen und tauschen Sie Informationen mit unserer KI oder den Experten aus.',

  tourTema: 'Themen',
  tourTemaMensagem: 'Wechseln Sie zwischen dem hellen und dem dunklen Thema.',

  tourNotificacoes: 'Benachrichtigungen',
  tourNotificacoesMensagem: 'Überprüfen Sie Aktualisierungen der Prozesse und konfigurieren Sie den Versand per E-Mail.',

  tourPerfil: 'Profil',
  tourPerfilMensagem: 'Bearbeiten Sie Ihre Daten, betrachten Sie die Neuigkeiten unserer Plattform, sehen Sie sich die Tour erneut an oder wechseln Sie das Zugangskonto.',

  tourMapaFuncionalidade: 'Kartenoptionen',
  tourMapaFuncionalidadeMensagem: 'Sie können die Karte zentrieren, vergrößern und verkleinern.',

  tourMapaFiltros: 'Kartenfilter',
  tourMapaFiltrosMensagem: 'Option zum Filtern der Prozesse nach Status.',

  tourObrigado: 'Vielen Dank für Ihre Aufmerksamkeit',
  tourObrigadoMensagem: 'Wenn Sie noch Fragen haben, wenden Sie sich bitte an unser Team.',

  removerDemanda: 'Möchten Sie diese Nachfrage entfernen?',
  possivelRecuperar: 'Ist eine Wiederherstellung nach dem Löschen möglich',
  proximo: 'Nächste',
  itemAdicionado: 'Artikel hinzugefügt! Artikel registrieren?',
  disponivelNCM:
    'Der Artikel wird in unserer Datenbank registriert und Sie können diesen Artikel in zukünftigen Vorgängen wiederverwenden.',
  fechar: 'Schließen',
  preenchaTudo: 'Füllen Sie alle Felder aus, bevor Sie einen Artikel registrieren.',
  produtoDeletado: 'Produkt erfolgreich gelöscht!',
  produtoSalvo: 'Produkt erfolgreich registriert!',
  produtoJaCadastrado: 'Das Produkt ist bereits registriert',
  ncmAutomatico:
    'Geben Sie den NCM-Code ein, wenn er in unserer Datenbank vorhanden ist, werden die Informationen automatisch, teilweise oder vollständig ausgefüllt.',
  configuracoes: 'Einstellungen',
  statusAlterado: 'Status geändert',
  hoje: 'Heute',
  ontem: 'Gestern',
  estaSemana: 'Diese Woche',
  semanaPassada: 'Letzte Woche',
  esteMes: 'Diesen Monat',
  anteriores: 'Zurück',
  assimQueAtualizar: 'Sobald Sie aktualisieren',
  diariamente: 'Täglich',
  semanalmente: 'Wöchentlich',
  desabilitarEnvio: 'Senden deaktivieren',
  dataRegistroDI: 'DI-Aufzeichnung',
  numeroProtocoloDI: 'DI-Protokollnummer',
  dataDesembaracoDI: 'DI-Freigabe',
  dataAbertura: 'Öffnung',
  dataFechamentoOperacional: 'Betriebsschließung',
  dataExecucaoCarregamento: 'Ausführung laden',
  carregamentoAgendado: 'Ladeplanung',
  dataFaturamento: 'Abrechnung',
  dataEnvioFaturamento: 'Versand der Rechnung der Sendung',
  emissaoNotaEntrada: 'Ausgabe des Eintrittsscheins',
  dataPresencaCarga: 'Belastungspräsenz',
  conhecimentoEmbarque: 'Frachtbrief',
  dataVistoriaMapa: 'MAPA-Inspektion',
  dataRecebimentoOriginais: 'Empfang von Dokumenten',
  cadastrarUsuario: 'Benutzer registrieren',
  listarUsuario: 'Benutzerliste',
  legenda: 'Infobox',
  refazerTour: 'Tour wiederholen',
  sairConta: 'Möchten Sie sich wirklich abmelden?',
  zoomIn: 'Hineinzoomen',
  zoomOut: 'Rauszoomen',
  centralizarMapa: 'Neu zentrieren',
  registroNaoEncontrado: 'Artikel nicht gefunden, versuchen Sie es erneut',
  processoNaoPossuiLocalizacaoMapa: 'Für das Element ist kein geografischer Standort registriert',
  avisoCamposObrigatorios: 'Mit * gekennzeichnete Felder müssen zwingend ausgefüllt werden.',
  maisDetalhes: 'Zugesagte Menge',
  codigoProduto: 'Produktcode',
  lote: 'Charge',
  loteFabricacao: 'Herstellungscharge',
  dataFabricacao: 'Herstellungsdatum',
  codigoPallet: 'Code-Palette',
  codigoSequenciaLote: 'Batch-Sequenz',
  dataMovimentacao: 'Umzugsdatum',
  numeroLote: 'Chargennummer',
  numeroLoteFabricacao: 'Chargennummer der Herstellung',
  quantidadeBloqueada: 'Gesperrte Menge',
  quantidadeEmpenhada: 'Zugesagte Menge',
  carregarTemplate: 'Vorlage laden',
  importarModelo: 'Modelldaten importieren',
  baixarModelo: 'Vorlage herunterladen',
  solteArquivos: 'Ziehen Sie Ihre Dateien per Drag & Drop hierher.',
  arquivosPermitidos: 'Erlaubte Dateien: XLSX, DOC und PDF.',
  solteCarregar: 'Ziehe die Dateien hier hin, um sie hochzuladen.',
  carregandoArquivos: 'Lade Daten...',
  verifiqueAntesSalvar: 'Überprüfen Sie die Felder vor dem Speichern.',
  processoExiste: 'Diese Referenznummer existiert bereits, prüfen.',
  valorTotal: 'Menge',
  codigoNCM: 'NCM-Code',
  descricaoDetalhada: 'Detaillierte Beschreibung',
  produtos: 'Produkte',
  tituloTooltipProdutos:
    'Registrieren Sie Produkte, um sie in Ihre Prozesse zu importieren und eine Historie von allem zu haben.',
  // MENSAGENS DE VALIDACOES CADASTRO DE PRODUTOS
  valorUnitarioPositivo: 'Der Einzelwert muss größer als Null sein',
  quantidadePositivo: 'Das Feld Menge muss größer als Null sein',
  preenchaCampoProdutor: 'Das Feld Produzent ist leer, bitte ausfüllen',
  preenchaCampoFornecedor: 'Das Feld Lieferant ist leer, bitte ausfüllen',
  preenchaCampoCodigoCliente: 'Das Kundencode-Feld ist leer, bitte füllen Sie es aus',
  preenchaCampoProduto: 'Das Produktfeld ist leer, bitte füllen Sie es aus',
  preenchaCampoUnidadeMedida: 'Das Feld für die Maßeinheit ist leer, bitte füllen Sie es aus',
  preenchaCampoNCM: 'Das Feld NCM-Code ist leer, bitte füllen Sie es aus',
  preenchaCampoMoeda: 'Währungsfeld ist leer, bitte wählen Sie eine der Währungen aus',
  preenchaCampoEmpresa: 'Das Firmenfeld ist leer, bitte wählen Sie eine der Firmen aus',
  maximo10characteres: 'Dieses Feld darf höchstens 10 Zeichen lang sein.',
  maximo20characteres: 'Dieses Feld darf höchstens 20 Zeichen lang sein.',
  maximo100characteres: 'Dieses Feld darf höchstens 100 Zeichen lang sein.',
  excluirUsuario: 'Benutzer löschen?',
  //////////////////////////////// ERROS
  ERRO_INTERNO_SERVIDOR_LOGIN:
    'Es tut uns leid, aber bei dem Versuch, sich anzumelden, ist ein interner Fehler aufgetreten. Wir arbeiten daran, das Problem zu beheben, und entschuldigen uns für die Unannehmlichkeiten. Bitte versuchen Sie es in ein paar Minuten erneut oder kontaktieren Sie unser technisches Support-Team für Unterstützung. Vielen Dank für Ihr Verständnis.',
  actions: 'Aktionen',
  ncm: 'NCM-Code',
  //TAREFAS
  pendente: 'Ausstehend',
  administrativo: 'Verwaltung',
  aguardando: 'Warten',
  regulatorio: 'Regulatorisch',
  novoProduto: 'Neues Produkt',
  cadastroNovoProduto: 'Neues Produkt',
  regulatorioCadastroNovoProduto: 'Neues Produkt / regulatorisch',
  REGULATORIOCADASTRONOVOPRODUTO: 'Neues Produkt / regulatorisch',
  cadastros: 'Registrierungen',
  cancelamentos: 'Stornierungen',
  acompanhamento: 'Verfolgung',
  liberacao: 'Freigabe',
  nacionalizacao: 'Nationalisierung',
  gestaoTarefas: 'Aufgabenverwaltung',
  id: 'ID',
  licenciamento: 'Lizenzierung',
  validacaoRegulatorio: 'Regulatorische Validierung',
  historico: 'Verlauf',
  processoMovido: 'Prozess verschoben nach',
  comentar: 'Kommentar',
  reenviarAcesso: 'Möchten Sie eine E-Mail mit einem neuen Zugang senden? Das aktuelle Passwort wird geändert.',
  tarefas: 'Aufgaben',
  tarefasProcessoPendente: 'Ausstehender Prozess',
  tarefasTratamentoAdministrativo: 'Verwaltungstätigkeit',
  tarefaRegulatorioCadastroNovoProduto: 'Neues Produkt / regulatorisch',
  tarefasAcompanhamento: 'Nachverfolgung nach Versand',
  tarefasLiberacao: 'Freigabe',
  tarefasNacionalizacao: 'Nationalisierung',
  tarefasFechamento: 'Abschluss',
  cardJaEstaEmAnaliseProduto: 'Diese Karte wurde bereits in der Phase "Neues Produkt / Regulatorisch" erstellt',
  atividades: 'Aktivitäten',
  atribuirMim: 'Mir zuweisen',
  proximaEtapa: 'Nächste Etappe',
  sim: 'Ja',
  nao: 'Nein',
  conferido: 'Überprüft',
  filtrosFavoritos: 'Lieblingsfilter',
  vincularFiltroModelo: 'Möchten Sie die letzte Suche/den letzten Filter mit diesem Modell verkn',
  concluidos: 'Abgeschlossen',
  esconderColunaConcluidos: 'Abgeschlossene Spalte ausblenden',
  exibirColunaConcluidos: 'Abgeschlossene Spalte anzeigen',
  //USUARIOS
  usuarioRemovido: 'Benutzer erfolgreich gelöscht',
  acessoEnviado: 'Der Zugang wurde an die E-Mail-Adresse des Benutzers gesendet',
  excluirProprioUsuario: 'Sie können Ihren eigenen Benutzer nicht löschen!',
  naoPodeReenviar: 'Sie können Ihre E-Mail und den ersten Zugriff nicht erneut senden!',
  usuarioAtualizado: 'Benutzer korrekt aktualisiert',
  usuarioInserido:
    'Benutzer korrekt eingefügt! Bitte warten Sie, bis das Passwort generiert und die E-Mail gesendet wurde',
  naoRecuperouUsuario: 'Die Benutzerdaten konnten nicht wiederhergestellt werden',
  formatoInvalido: 'Das Format des Feldes ist ungültig!',
  nomeLetras: 'Der Name muss mindestens 3 Buchstaben enthalten!',
  nomeMaxLetras: 'Der Name darf maximal 50 Buchstaben enthalten!',
  campoObrigatorio: 'Dieses Feld ist Pflichtfeld!',
  emailFormato: 'Ungültiges E-Mail-Format.',
  emailMaxLetras: 'Das E-Mail-Feld darf maximal 80 Buchstaben enthalten!',
  especifiqueUsuario: 'Geben Sie den Benutzertyp an',
  senhaLetras: 'Das Passwort muss mindestens 8 Zeichen enthalten.',
  senhaMaxLetras: 'Das Passwort darf maximal 25 Zeichen enthalten.',
  senhaDiferentes: 'Die Passwörter sind nicht gleich.',
  historicoCompleto: 'Kompletter Verlauf-Modus',
  descricaoHistorico:
    '<p>Das historische Modell enthält in jeder Aktualisierungs-E-Mail <span style:"text-decoration: underline">alle durchlaufenen Schritte</span> des Prozesses mit Datum und Kontext. Sie können die Schaltfläche aktivieren und es in diesem Format erhalten.</p> <p>Wenn Sie es deaktivieren, enthält der Inhalt der E-Mail nur das letzte Update.</p>',
  limpar: 'Reinigen',
  ativo: 'Aktivieren',
  desativado: 'Deaktiviert',
  naoDigiteUnidadeMedida: 'Geben Sie die Maßeinheit nicht ein',
  avisoViaEmail: 'Benachrichtigung per E-Mail erhalten?',
  emailsDestinos: 'Ziel-E-Mails',
  estoque: 'Lager',
  estoqueDisponivel: 'Verfügbares Lager',
  estoqueLimite: 'Vorrat geht zur Neige oder ist ausverkauft',
  receberAvisoEstoqueText: 'Geben Sie in der Tabelle an, wenn der Bestand * ist',
  estoqueMinimoAtualizadoSucesso: 'Mindestbestand wurde erfolgreich aktualisiert.',
  minimoEstoqueDesejado: 'Gewünschter Mindestbestand',
  naoDefinido: 'Nicht definiert',
  legendaSemConfiguracaoEstoqueMinimo: 'Konfiguration nicht definiert',
  legendaEmailDesativadoErroEstoqueMinimo:
    'E-Mail-Versand deaktiviert und Bestand unter dem definierten Minimum',
  legendaEmailDesativadoEstoqueMinimo:
    'Aktiver E-Mail-Versand und Bestand über dem definierten Minimum',
  legendaEstoqueMinimoAlerta: 'Der Bestand liegt unter dem definierten Minimum',
  legendaEstoqueMinimoErro: 'Lager ist ausverkauft',
  legendaEstoqueMinimoIdeal: 'Der aktuelle Bestand liegt über dem definierten Minimum',
  formatoCampoEmailInvalido: 'E-Mail-Format ungültig',
  requiredFieldValorEstoqueMinimo: 'Feld Mindestbestand leer',
  requiredFieldTypeErrorNumber: 'Das Feld Mindestbestand muss eine Zahl sein',
  requiredFieldEmail:
    'Das Feld E-Mail ist leer, bitte geben Sie mindestens eine gültige E-Mail-Adresse ein.',
  // AG-GRID
  equals: 'Gleich',
  notEqual: 'Anders als',
  blank: 'Leer',
  notBlank: 'Nicht leer',
  contains: 'Enthält',
  notContains: 'Beinhaltet nicht',
  startsWith: 'Beginnt mit',
  endsWith: 'Endet mit',
  filter: 'filter',
  andCondition: 'ES',
  orCondition: 'ODER',
  busqueCNPJ: 'Suchen Sie nach Unternehmen nach Namen oder CNPJ.',
  removerEmpresas: 'Unternehmen entfernen',
  aplicar: 'Bewerben',
  cliqueCardDetalhes: 'Klicken Sie auf die Karte für weitere Details',
  fechamento: 'Schließung',
  pending: 'Ausstehend',
  in_transit: 'Auf der Durchreise',
  occurrence_treatment: 'Behandlung des Vorkommens',
  done: 'Geliefert',
  motorista: 'Treiber',
  placa: 'Platte',
  valorNF: 'Rechnungswert',
  pesoRealNF: 'Tatsächliches Gewicht in Rechnung stellen',
  tituloEstoqueMinimo: 'Mindestbestand',
  buscaAvancada: 'Erweiterte Suche',
  codProcesso: 'Code Verfahren',
  paisOrigem: 'Herkunftsland',
  paisDestino: 'Zielland',
  placaRodoviario: 'Platte (Straße)',
  dataEntregaContainer: 'Container Lieferdatum',
  removerSelecionados: 'Ausgewählte entfernen',
  marcarDesmarcarTodos: 'Alle auswählen / Auswahl aufheben',
  salvarUmFiltro: 'Einen Filter speichern',
  criarUmNovoFiltro: 'Einen Lieblingsfilter erstellen',
  editarFiltro: 'Filter bearbeiten',
  filtroSalvo: 'Filter erfolgreich gespeichert',
  filtroAtualizado: 'Filter aktualisiert',
  fltroAplicado: 'Filter angewendet',
  // Tarefas atividades novoProduto
  recebimentoDescricao: 'Empfang von Beschreibung / NCM / Lieferantendaten',
  formularioCadastroProduto: 'Formular für die Registrierung von Produkten',
  formularioCadastroFornecedores: 'Formular für die Registrierung von Lieferanten',
  aberturaChamadoCadastro: 'Öffnen des Registrierungsaufrufs',
  produtoCadastrado: 'Registriertes Produkt',
  // Tarefas atividade regulatório
  envioFormularioRegulatorio: 'Senden von Formularen an die Regulierungsabteilung',
  envioDocumentos: 'Senden von Dokumenten / MSDS / FISPIQ',
  pendenciaDocumental: 'Dokumentarische / informationelle ausstehende Fragen',
  analiseRegulatorioLiberado: 'Regulierungsanalyse freigegeben',
  // Tarefas atividade acompanhamento
  cadastroConhecimentoConexos: 'Registrierung des Konnossements in Conexos',
  emissaoLiPosEmbarque: 'Ausstellung der LI nach dem Versand',
  documentosOriginais: 'Originale Dokumente',
  telex: 'Telex',
  conferenciaCeMercante: 'Händler-CE-Konferenz',
  envioNumerario: 'Geldversand',
  digitacaoDI: 'DI-Typisierung',
  lancamentoMapaMadeira: 'Madeira-Karten-Eintrag',
  verificacaoValorConta: 'Kontowertüberprüfung',
  autorizacaoRegistroDI: 'DI/AFRMM-Registrierungsberechtigung',
  // Tarefas atividades liberacao
  envioDiRegistrada: 'Versand der registrierten DI',
  envioCI: 'Versand der CI',
  pagamentoTaxaBL: 'Zahlung von BL / Frachtgebühren',
  envioDocumentacaoLiberacaoBL: 'Versand der BL-Freigabedokumentation',
  desbloqueioSiscarga: 'Siscarga entsperren',
  solicitarExoneracaoICMS: 'ICMS-Befreiung beantragen',
  montarNF: 'Rechnungszusammenstellung / Überprüfung der Ausgaben für Rechnung',
  liberacaoComex: 'Comex-Freigabe',
  recebimentoNfTrust: 'Erhalt der NF Trust',
  programacaoCarregamento: 'Planung der Be- und Entladung des Kunden und des Transports',
  liberacaoFaturamentoTerminal: 'Freigabe der Terminalabrechnung',
  agendamentoRetirada: 'Abholplanung',
  minutaDevolucaoCNTR: 'CNTR-Rückgabeentwurf',
  lavacaoAvaria: 'Reinigung / Schaden',
  demurrage: 'Lagergeld',
  envioFechamento: 'Versenden zur Schließung',
  // Tarefas atividades fechamento
  recebimento: 'Empfang',
  verificacaoRazaoProcesso: 'Prozessgrundprüfung',
  envioFechamentoCliente: 'Senden von Abschluss an Kunden',
  gestaoLicencasImportacao: 'Importlizenzverwaltung',
  gestaoLI: 'Importlizenzverwaltung',
  licencaImportacao: 'Importlizenz',
  visualizeLI:
    'Verfolgen Sie die erforderlichen Lizenzen für den Import, um die Regulierung des internationalen Handels und den Schutz der nationalen Wirtschaft zu gewährleisten.',
  dataSituacao: 'Statusdatum',
  li: 'IL',
  dataReg: 'Registrierungsdatum',
  validadeSituacao: 'Statusgültigkeit',
  dataProtocolo: 'Protokolldatum',
  anuencia: 'Zustimmung',
  paraAnalise: 'Analysieren',
  emExigencia: 'In Anforderung',
  deferida: 'Genehmigt',
  encaminhar: 'Senden',
  encaminharProcessoEmail: 'Vorgang per E-Mail senden',
  verMais: 'Mehr anzeigen',
  verMenos: 'Weniger sehen',
  dataTransbordo: 'Überweisung',
  dataTransbordo2: 'zweite Überweisung',
  sequencia: 'Reihenfolge',
  ultimoAcesso: 'Letzter Zugriff',
  cliqueAdicionarProduto: 'Klicken Sie, um ein neues Produkt hinzuzufügen',
  house: 'BL-Haus',
  master: 'BL-Meister',
  tipoContainer: 'Containertyp',
  armador: 'Reederei',
  lacre: 'Siegel',
  dataChegadaContainer: 'Containerankunft',
  vencimentoFreetime: 'Freetime-Verfall',
  situacaoEvento: 'Ereignisstatus',
  containerDevolvido: 'Container zurückgegeben',
  dataEvento: 'Ereignisdatum',
  situacaoEventoArmador: 'Ereignisstatus der Reederei',
  nomeNavio: 'Schiffsname',
  localEvento: 'Ereignisort',
  identificacaoViagem: 'Reiseidentifikation',
  dataViagem: 'Reisedatum',
  Modalidade: 'Modalität',
  Porcentagem: 'Prozentsatz',
  Valor: 'Wert',
  Invoice: 'Invoice',
  'Tipo vencimento': 'Fälligkeitstyp',
  statusDoProcesso: 'Status des Prozesses',
  reenviarEmailProcesso: 'Prozess-E-Mail erneut senden',
  erroAoEnviarEmail: 'Beim Senden der E-Mail ist ein Fehler aufgetreten',
  aperteEnterParaCadaEmail: 'Drücken Sie für jede eingegebene E-Mail-Adresse die Eingabetaste',
  tipoDeImportacao: 'Importtyp',
  cliqueParaBaixar: 'Klicken Sie hier zum Herunterladen',
  Abertos: "Geöffnet",
  Encerrados: "Geschlossen",
  extratoLI: 'Lizenzauszug',
  // INCENTIVO FISCAL
  incentivoFiscal: 'Steueranreiz',
  icmsPago: 'ICMS Bezahlt',
  aliquotaIcmsPago: 'ICMS Steuersatz bezahlt',
  formaDesconto: 'Rabattform',
  descontoIcmsPago: 'ICMS Rabatt bezahlt',
  pctCliente: '% BC Kunde',
  pctGanhoLiquido: '% Nettogewinn',
  valorCliente: 'Kundenwert',
  porcentagemCliente: '% Kunde',
  pctEmpresa: '% Unternehmen',
  // GED
  documentoBaixadoSucesso: 'Dokument erfolgreich heruntergeladen',
  erroBaixarDocumento: 'Beim Herunterladen des Dokuments ist ein Fehler aufgetreten',
  erroVisualizarDocumento: 'Beim Anzeigen des Dokuments ist ein Fehler aufgetreten',
  // gestao containers
  containersNaoEncontrados: 'Container für diesen Filtertyp nicht gefunden.',
  //Produtos Processos
  'PET - RESINA': 'PET - HARZ',
  'PVC - RESINA': 'PVC - HARZ',
  'PROPRIO DIVERSOS': 'EIGEN VERSCHIEDENE',
  'SUPLEMENTOS': 'ERGÄNZUNGSMITTEL',
  // GRÁFICOS
  indicadores: 'Indikatoren',
  licencasDeferidas: 'Erteilte Lizenzen',
  licencasComExigencia: 'Lizenzen mit Anforderungen',
  licencasSemExigencia: 'Lizenzen ohne Anforderungen',
  tempoAberturaDeferimento: 'Zeit von der Eröffnung bis zur Genehmigung (Tage)',
  expectativaChegada: 'Ankunftserwartung',
  codCalculo: "Berechnungscode Einnahmen/Kosten",
  estadoCalculo: "Berechnungsstatus Einnahmen/Kosten",
  dataInicio: "Startdatum",
  dataFim: "Enddatum",
  valorServico: "Dienstleistungswert",
  valorCalculado: "Berechneter Wert",
  ordemCompra: 'Bestellung',
  aVista: 'In bar',
  aPrazo: 'Raten',
  termosPagamento: 'Zahlungsbedingungen',
  portoOrigem: 'Herkunftshafen',
  portoDestino: 'Zielhafen',
  enderecoExportador: 'Exporteuradresse',
  selecionarCNPJ: 'Wählen Sie DOCs aus und fügen Sie sie dem Benutzer hinzu',
  vincular: 'Verknüpfung',
  manutencoes: 'Wartung',
  // TabName
  'Login': 'Anmeldung',
  'Home': 'Startseite',
  'AberturaProcesso': 'Neue Prozesse',
  'ProcessosKanban': 'Follow-Up',
  'GestaoLI': 'LI-Verwaltung',
  'ListagemProcesso': 'Prozessliste',
  'TransitTime': 'Transitzeit',
  'Estoque': 'Vorrat',
  'Financeiro': 'Finanzwesen',
  'AgendamentoRelatorios': 'Berichte',
  'Ged': 'Elektronisches Dokumentenmanagement',
  'Mensageiro': 'Bote',
  'Tarefas': 'Aufgabenmanagement',
  'ListarUsuarios': 'Benutzer',
  'Produtos': 'Produkte',
  'Dashboard': 'Dashboard',
  'Empresas': 'Unternehmen',
  'RecuperarSenha': 'Passwort wiederherstellen',
  'processosParceiros': 'Partner',
  'processosComissao': ' Partner',
  bugs: 'Bugs: ',
  melhorias: 'Verbesserungen: ',
  manutencao: 'Wartung: ',
  novidades: 'Neuigkeiten: ',
  patchNotes: 'Update-Notizen',
  assistente: 'Assistent',
  assistente1: 'Assistent 1',
  assistente2: 'Assistent 2',
  assistentes: 'Assistents',
  introPatchNotes1: 'Dies sind nur einige der Verbesserungen und Funktionen, die in jeder Version von Trinity eingeführt wurden. Wir sind stets bemüht, die Plattform zu verbessern und Ihnen das bestmögliche Erlebnis zu bieten.',
  introPatchNotes2: 'Wir werden Informationen über zukünftige Versionen und spannende neue Funktionen teilen, die noch kommen werden.',
  manutecoes: 'Wartungen',
  acoes: 'Aktionen',
  aguardandoAtualizacao: 'Warte auf Update',
  copiarLinkProcesso: 'Prozesslink kopieren',
  estrategico: 'Strategisch',
  chat: 'Plaudern',
  entendi: 'Ich verstehe',
  aindaNaoembarcado: 'Noch nicht verschickt',
  seuProcessoAindaNaoEmbarcado: 'Ihr Prozess wurde noch nicht verschickt.',
  fiqueOlho: 'Behalten Sie die nächsten Tage im Auge.',
  ops: 'Hoppla',
  processoNaoEncontrado: 'Dieser Prozess wurde nicht gefunden.',
  naoRegistrado: 'Ihr Schiff könnte sich in einem Bereich ohne Radar befinden oder möglicherweise nicht registriert worden sein.',
  transporteAereo: 'Lufttransport',
  seuProcessoAereo: 'Ihr Prozess befindet sich im Lufttransportmodus.',
  naoApareceMapa: 'Dieser Modus wird derzeit nicht auf der Karte angezeigt.',
  transitoConcluido: 'Transit abgeschlossen',
  processoNaoTransito: 'Ihr Prozess befindet sich nicht mehr im Transit.',
  cliqueDetalhesProcesso: 'Klicken Sie, um die Details dieses Prozesses anzuzeigen.',
  verDetalhes: 'Details anzeigen',
  // CRC
  crcMenu: 'Lagerkosten',
  crc: 'Lagerkosten',
  codigoCRC: 'Code für Einnahmen/Kosten-Berechnung',
  estadoCRC: 'Status der Einnahmen/Kosten-Berechnung',
  descricaoServico: 'Servicebeschreibung',
  quantidadeServico: 'Serviceanzahl',
  editarEmpresa: 'Firma bearbeiten',
  cadastroBasico: 'Grundlegende Datensätze',
  fornecedorProdutor: 'Lieferant / Produzent',
  siglaSimbolo: 'Abkürzung/Symbol',
  Cadastro: 'Datensatz',
  salvoComSucesso: 'erfolgreich gespeichert',
  deletadoComSucesso: 'wurde erfolgreich gelöscht',
  sigla: 'Abkürzung',
  tipo: 'Typ',
  alta: 'Hoch',
  media: 'Durchschnitt',
  baixa: 'Niedrig',
  prioridade: 'Priorität',
  // DNA Empresas
  sequencial: 'Sequenziell',
  questionario: 'Fragebogen',
  questionarios: 'Fragebögen',
  perguntas: 'Fragen',
  respostas: 'Antworten',
  perguntasAndRespostas: 'Fragen und Antworten',
  responsavelComex: 'Comex-Manager',
  assistenteComex: 'Comex-Assistent',
  responsavelExecutivo: 'Executive-Manager',
  //
  totalProcessosDescricao: "Laufende Prozesse nach Status",
  statusProcessosDescricao: "In Bezug auf die ursprüngliche Versandprognose",
  canalParametrizacaoDescricao: "In Bezug auf laufende Prozesse",
  topProdutosDescricao: "In Bezug auf die Anzahl der Rechnungen",
  acertoNumerarioDescricao: "Im Verhältnis zwischen geschätztem Wert und realisiertem Wert",
  tempoLiberacaoFechamentoDescricao: "In Bezug auf das Datum der Warenpräsenz",
  //
  placeholderFornecedorProdutorInputNome: 'Beispielunternehmen GmbH',
  placeholderFornecedorProdutorInputCNPJ: '00.000.000/0001-00',
  placeholderMoedaInputSiglaSimbolo: 'USD',
  placeholderMoedaInputDescricao: 'US-Dollar',
  placeholderUnidadeMedidaInputSiglaSimbolo: 'KG',
  placeholderUnidadeMedidaInputDescricao: 'Kilogramm',
  recuperarRascunho: 'Entwurf wiederherstellen',
  messageFügeNeuesElementHinzu: "Wenn Sie ein neues Element hinzufügen möchten, wenden Sie sich bitte an einen Administrator.",
  mensagemCampoDescricaoCadastroBasico: 'Das Beschreibungsfeld muss mindestens 5 Zeichen enthalten.',
  mensagemCampoSiglaMoeda: 'Das Abkürzungsfeld muss mindestens 3 Zeichen enthalten.',
  mensagemCampoSiglaUnidadeMedida: 'Das Abkürzungsfeld muss mindestens 2 Zeichen enthalten.',
  mensagemCampoNomeFornecedorProdutor: 'Das Namensfeld muss mindestens 5 Zeichen enthalten.',
  mensagemCampoCNPJFornecedorProdutor: 'Das CNPJ-Feld muss nicht formatiert werden; nur die Zahlen sind ausreichend.',
  mensagemCampoCNPJLenghtFornecedorProdutor: 'Das CNPJ-Feld muss 14 Zeichen enthalten.',
  previsao: 'Prognose',
  cadastrosBasicos: 'Grundlegende Registrierung',
  // Simulação
  Simulacao: 'Simulation',
  simulacao: 'Simulation',
  classificacao: 'Einstufung',
  filial: 'Partner/Vorteile',
  solicitadoEm: 'Angefordert in',
  recuperarSenha: 'Passwort wiederherstellen',
  nenhumaEmpresaColuna: 'Kein Unternehmen in dieser Spalte',
  nunhumProcessoEncontrado: 'Es wurde kein neuer Prozess gefunden',
  abrirVisualizarAndamentoFollowup: 'Sie können einen neuen Prozess starten oder den Fortschritt im Follow-Up ansehen',
  tooltipDataLiberacaoSiscarga: 'Freigabedatum des B/L (Rückzug der Zurückhaltung)',
  tooltipDataLiberacaoMapa: 'Datum, an dem das Landwirtschaftsministerium die Holzverpackung der Ware freigibt',
  tooltipPresencaCarga: 'Datum, an dem der Zollbereich mitteilt, dass der Container im Terminal ist',
  LI: 'LI',
  II: 'II',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  'COFINS CUSTO': 'COFINS KOSTEN',
  ICMS: 'ICMS',
  'PIS SAIDA': 'PIS AUSFAHRT',
  'COFINS SAIDA': 'COFINS AUSFAHRT',
  'MARKTUP': 'MARKTUP',
  'DESCONTO': 'RABATT',
  comissoes: 'Provisionen',
  parceiros: 'Importieren fördert das Wachstum',
  DashboardContainers: "Dashboard",
  min: "Minimum",
  max: "Maximum",
  avg: "Durchschnitt",
  median: "Median",
  count: "Anzahl",
  escolhaAbaixo: 'Wählen Sie unten',
  referenciaProcesso: 'Prozessreferenz',
  valorComissao: 'Provisionsbetrag',
  parcelasPagamento: 'Zahlungsraten',
  dataComissao: 'Provisionsdatum',
  icms: 'ICMS',
  valorIcms: 'ICMS Betrag',
  tipoImportacao: 'Importarttyp',
  ocultar: 'Ausblenden',
  exibir: 'Anzeigen',
  'Cliente': 'Kunde',
  nomeArquivo: 'Dateiname',
  novoProcesso: 'Neuer Prozess',
  referenciaPO: 'Referenz (PO oder Rechnung)',
  expandirDiminuir: 'Erweitern / Reduzieren',
  downloadPDF: 'Download PDF',
  recarregar: 'Refresh',
  // Pré faturamento
  preFaturamento: 'Vorababrechnung',
  carregamentoProgramado: 'Geplante Beladung',
  horario: 'Zeitplan',
  liberacaoMapa: 'Kartenfreigabe',
  liberacaoSiscarga: 'Siscarga-Freigabe',
  transportador: 'Spediteur',
  taxaCambialDI: 'Devisenkurs D.I',
  beneficioFiscal: 'Steuerlicher Vorteil',
  descricaoItem: 'Artikelbeschreibung',
  despachante: 'Zollagent',
  armazemDesembaraco: 'Zollfreilager',
  recintoEntrada: 'Eingangsbereich',
  codigoInvoice: 'Rechnungscode',
  quantidadeContainers: 'Anzahl der Container',
  quantidadeLIs: 'Anzahl der LI\'s',
  diasLivres: 'Freie Tage',
  CE: 'C.E',
  desembaraco: 'Zollabfertigung',
  saldoConta: 'Kontostand',
  custosAlocadosOutroProcesso: 'Kosten aus einem anderen Prozess zugeteilt',
  THC: 'THC',
  observacoesProcesso: 'Prozessbeobachtungen',
  codigo: 'Code',
  emissao: 'Ausstellung',
  numeroDocumento: 'Dokumentennummer',
  adiantamento: 'Vorauszahlung',
  descricaoPessoa: 'Personenbeschreibung',
  uf: 'Bundesland',
  umAdicao: 'Zusatznummer',
  numItem: 'Artikelnummer',
  codigoExportacao: 'Exportcode',
  contaProjeto: 'Projektkonto',
  valorMoedaNacional: 'Wert in Landeswährung',
  formaRateio: 'Verteilungsform',
  encargo: 'Gebühr',
  ONU: 'UNO',
  descricaoCliente: 'Kundenbeschreibung',
  embalagem: 'Verpackung',
  nomePasta: 'Ordnername',
  informacoesProcesso: 'Prozessinformationen',
  financeiroPagar: 'Zu zahlende Finanzen',
  comparativoProdutosDIs: 'Vergleich Produkt(e) D.I.',
  comparativoProdutoInvoice: 'Vergleich Produkt Invoice',
  custosEmissaoNF: 'Kosten für die Ausstellung der NF',
  produtosProcesso: 'Prozessprodukte',
  documentosGED: 'GED-Dokumente',
  comparativosProdutoDIs: 'Vergleich Produkt(e) D.I.',
  mensagemRascunhos: 'Fassen Sie die Informationen früherer Anfragen zusammen, die nicht abgeschlossen wurden.',
  editarSolicitacaoProcesso: 'Prozessanforderung bearbeiten',
  prazoPagamento: 'Zahlungsfrist',
  downloadExcel: 'Tabelle als Excel herunterladen',
  substituta: 'Ersatz',
  limparFiltros: 'Filter löschen',
  valoresInvoice: 'Gesamtrechnungsprodukte',
  DiasRestantesChegada: 'Verbleibende Tage bis zur Ankunft',
  dataMovimento: 'Bewegungsdatum',
  segmentoProduto: "Produktsegment",
  valorProcesso: "Gesamtwert des Prozesses",
  dataChegouPorto: 'Fracht ist am Zielhafen angekommen',
  previsaoDemandaDomestica: 'Inlandsnachfrageprognose',
  PrevisaoDemandaDomestica: 'Inlandsnachfrageprognose',
  demandaDomestica: 'Inlandsnachfrage',
  processosPendentes: 'Ausstehende Prozesse',
  bl: 'BL',
  enviosEmail: 'E-Mail-Einreichungen',
  esteProcessoPossui: 'Dieser Prozess hat',
  um: 'Der',
  acabouAberto: 'wurde gerade eröffnet',
  "tooltipAbertura": "Formeller Beginn des Importprozesses mit der Handelsfirma, Beginn rechtlicher und administrativer Verfahren.",
  "tooltipDataEmbarque": "Tag, an dem die Waren tatsächlich auf das Transportmittel geladen werden, um vom Herkunftsland in das Zielland geschickt zu werden.",
  "tooltipRegistroDI": "Die Importerklärung erfasst Details wie Herstellerdaten, Importeur, Steuerklassifizierung und Steuerwerte. Es ist eine Voraussetzung für die Zollabfertigung.",
  "tooltipVistoriaMapa": "Das Ministerium für Landwirtschaft, Viehzucht und Versorgung ist für die Überwachung des internationalen Transits von Verpackungen verantwortlich und verhindert das Eindringen von Schädlingen.",
  "tooltipETA": "Geschätztes Ankunftsdatum des Schiffes im Hafen.",
  "tooltipETD": "Geschätztes Abreisedatum des Schiffes aus dem Hafen.",
  "tooltipRecebimentoOriginais": "Dies sind die anleitenden Dokumente des Prozesses, zum Beispiel: Rechnung, Packliste und BL.",
  "tooltipTransbordo": "Die Waren müssen während der Reise das Schiff wechseln, entlang der bereits festgelegten Route.",
  "tooltipSegundoTransbordo": "Die Waren müssen während der Reise zum zweiten Mal das Schiff wechseln, entlang der bereits festgelegten Route.",
  "tooltipDataLiberaciónMapa": "Datum, an dem das Ministerium für Landwirtschaft, Viehzucht und Versorgung die Freigabe der Waren durch dokumentarische oder physische Inspektion autorisiert.",
  "tooltipDataChegada": "Moment, in dem die importierten Waren den Zielhafen erreichen und den Beginn der Zoll- und logistischen Verfahren markieren.",
  "tooltipDesembaracoDI": "Zollabfertigung der Importerklärung. Sie umfasst die Analyse und Genehmigung durch den Zoll von Importdokumenten und ermöglicht die Freigabe von Waren.",
  "tooltipConhecimentoEmbarque": "Auch bekannt als Konnossement (B/L), dient es als Quittung für die versandten Waren und als Dokument des Besitztitels der Waren während des Transports.",
  "tooltipEmissãoNotaEntrada": "Generierung eines Steuerdokuments durch das importierende Unternehmen, das zur Formalisierung des Eingangs von im Ausland erworbenen Produkten dient.",
  "tooltipDataCarregamento": "Datum, an dem die Beladung des Prozesses geplant ist oder bereits erfolgt ist.",
  "tooltipExecucaoCarregamento": "Datum, an dem der Container aus dem Hafen entfernt wurde.",
  "tooltipCarregamentoAgendado": "Planung des Zeitpunkts, zu dem die Waren auf das Fahrzeug geladen und aus dem Hafen entfernt werden. Ich bin mir nicht sicher, ob Trinity dieses Datum hat.",
  "tooltipFechamentoOperacional": "Abschluss logistischer und administrativer Operationen im Zusammenhang mit der Einfuhr.",
  "tooltipDataFaturamento": "Ausstellung der elektronischen Rechnung mit Angabe von Warenbeschreibung, Mengen, Preisen, Zahlungsbedingungen usw.",
  "tooltipEnvioFaturamento": "Datum, an dem die elektronische Rechnung über das System versandt wurde.",
  ForgotPassword: 'Ich habe mein Passwort vergessen',
  consultarProcessos: "Prozesse konsultieren",
  realizarCotacao: "Angebot erstellen",
  documentosGerais: "Allgemeine Dokumente",
  fretes: "Frachten",
  performance: "Leistung",
  analiseFrete: "Frachtanalyse",
  acuraciaEstoque: "Bestandsgenauigkeit",
  eficaciaGeral: "Gesamtwirksamkeit",
  basicos: "Grundlagen",
  portuariaVigentes: "Aktueller Hafen",
  tarefasComex: "COMEX-Aufgaben",
  interno: "Intern",
  armazenamento: "Lagerung",
  gerais: 'Allgemeine',
  sugerirTrasnportadora: 'Spediteur vorschlagen',
  responsavelFrete: 'Frachtverantwortlich',
  agenciamentoInternacional: 'Internationales Agenturgeschäft',
  acuraciaArmazem: 'Gesamteffektivität des Lagerbetriebs',
  operacional: 'betriebsbereit',
  deProcesso: 'des Prozesses',
  esteEMais: 'Dies und mehr',
  processosForamEncerrados: 'prozesse wurden geschlossen',
  esteProcessoEncerrado: 'Dieser Prozess wurde abgeschlossen',
};
